import React, { useState } from "react";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import NRLogo from "assets/NRLogo";
import styles from "./Login.module.scss";
import formstyles from "forms/Forms.module.scss";
import useIndexedDb from "hooks/useIndexedDb";
import { getEnvs } from "../../env";

const LoginForm: React.FC = () => {
	const history = useHistory();
	const validate = (values: any) => {
		const errors: any = {};
		if (!values.userName) {
			errors.userName = "Required";
		}
		return errors;
	};

	const setServerUrl = async () => {
		try {
			let serverUrl;
			const envvars: any = await getEnvs();
			serverUrl = envvars.REACT_APP_SERVER_URL_API;
			return serverUrl;
		} catch (err) {
			console.error("error: ", err);
		}
	};

	const checkLoginAuth = async (username: string, password: string) => {
		let response;
		try {
			const SERVER_URL = await setServerUrl();
			response = await fetch(`${SERVER_URL}/authentication`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				credentials: "include",
				body: JSON.stringify({
					username,
					password,
					mobileLogin: false,
					groups: "A-MOB-LinesideBuildings-Super",
				}),
			});
		} catch (err) {
			console.log(err);
		}
		return response;
	};
	const [authenticated, setAuthenticated] = useState(false);
	const [AuthenticationMessage, setAuthenticationMessage] = useState<string>("");

	const IDBData = useIndexedDb(authenticated);

	const formik = useFormik({
		initialValues: {
			userName: "",
			password: "",
		},
		validate,
		onSubmit: async (values, { setFieldValue }) => {
			const response = await checkLoginAuth(values.userName, values.password);
			if (response?.status !== 200) {
				if (response?.status === 401) {
					setFieldValue("password", "");
					setAuthenticationMessage("Incorrect details. Please try again.");
					return;
				}
				setFieldValue("password", "");
				setAuthenticationMessage(
					"Unable to fetch data due to a network issue."
				);
				return;
			}
			if (response.ok) {
				setAuthenticationMessage("Please wait... checking for new data...");
				setAuthenticated(true);
				history.push("/main");
				return;
			}
		},
	});

	const { handleBlur, handleChange, values, handleSubmit } = formik;

	return (
		<div>
			<form
				className={formstyles.Form + " " + styles.FormOverride}
				onSubmit={handleSubmit}
			>
				<input
					id="userName"
					name="userName"
					type="text"
					placeholder="Username"
					onChange={handleChange}
					value={values.userName}
					onBlur={handleBlur}
				/>

				<input
					id="password"
					name="password"
					type="password"
					placeholder="Password"
					onChange={handleChange}
					value={values.password}
					onBlur={handleBlur}
				/>

				<button className={formstyles.loginButton} type="submit">
					Login
				</button>
				<p className={styles.authenticationError}>{AuthenticationMessage}</p>
			</form>
		</div>
	);
};

const Heading: React.FC = () => {
	return (
		<div className={styles.Heading}>
			<h1>
				<span>Lineside</span>
				<br />
				<span>Buildings</span>
				<br />
				<span>Locator</span>
			</h1>
		</div>
	);
};

const Login: React.FC = () => {
	return (
		<>
			<div className={styles.Wrapper}>
				<div className={styles.mainContent}>
					<div className={styles.Header}>
						<NRLogo />
						<Heading />
					</div>
					<LoginForm />
				</div>
					<a className={styles.PrivacyButton} href="https://public.nrdigital.co/LSB/LSB+Portal+Privacy+Statement.pdf" target="_blank">
						<span>Privacy Statement</span>
					</a>
				<div className={styles.PrivacyVector} />
			</div>
		</>
	);
};

export default Login;
